// Conservation de la destination d'un raccourci pendant la connexion (membre ou équipe).
// Jamais de jeton dans l'URL ; seules les destinations internes (chemin relatif commençant par "/") sont acceptées.
const KEY = "dojova_return_to";
const TTL_MS = 20 * 60 * 1000; // survit au détour Google et au changement de contexte (app installée ↔ navigateur)

export function safeInternalPath(p, fallback) {
  if (typeof p !== "string") return fallback;
  if (!p.startsWith("/") || p.startsWith("//") || /^\/\\|^\/[a-z]+:/i.test(p)) return fallback;
  if (/session_id=|token=|password/i.test(p)) return fallback;
  return p;
}

export function rememberReturnTo(path) {
  const p = safeInternalPath(path, null);
  if (p && p !== "/auth" && p !== "/membres") localStorage.setItem(KEY, JSON.stringify({ p, t: Date.now() }));
}

// `scope` : "/app" pour l'équipe, "/membres" pour les membres — une destination d'un autre parcours est ignorée.
export function consumeReturnTo(fallback, scope) {
  let v = null;
  try { const raw = JSON.parse(localStorage.getItem(KEY) || "null"); if (raw && Date.now() - raw.t < TTL_MS) v = raw.p; } catch { v = null; }
  localStorage.removeItem(KEY); sessionStorage.removeItem(KEY);
  const p = safeInternalPath(v, fallback);
  const sc = scope || (fallback.startsWith("/membres") ? "/membres" : "/app");
  return p && p.startsWith(sc) ? p : fallback;
}

// Sections adressées par CHEMIN (/membres/checkin). Les fragments (#checkin) restent acceptés mais ne sont pas fiables
// dans les raccourcis d'écran d'accueil (iOS/Android peuvent les retirer de start_url).
export const MEMBER_SECTIONS = { checkin: "member-checkin", carnet: "member-academy-hub", "carnet-progression": "module-carnet", paiements: "member-payment-card", dossier: "member-dossier", equipement: "member-equipment-hub", horaire: "module-horaire" };

export function memberSectionKey(pathname, hash) {
  const fromPath = (pathname || "").replace(/^\/membres\/?/, "").split("/")[0].replace(/[^a-z-]/g, "");
  const fromHash = (hash || "").replace("#", "").replace(/[^a-z-]/g, "");
  const k = fromPath || fromHash;
  return MEMBER_SECTIONS[k] ? k : "";
}

export function memberSectionPath(key) {
  return key && MEMBER_SECTIONS[key] ? `/membres/${key}` : "/membres";
}

export function scrollToMemberHash(hash) {
  const id = MEMBER_SECTIONS[(hash || "").replace("#", "")];
  if (!id) return false;
  let tries = 0;
  const tick = () => {
    const el = document.querySelector(`[data-testid="${id}"]`);
    if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
    if (tries++ < 20) setTimeout(tick, 250);
  };
  tick();
  return true;
}
